import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import {
  BannerSection,
  BenefitsSection,
  CtaSection,
  HeroSection,
  PromoSection,
  SmallPrintSection,
} from '../sections';
import { LandingVariantProps } from './types';

/**
 * Variant B — the pre-experiment page: phone CTA plus the online
 * registration link. This is also the fallback whenever the experiment flag
 * is unavailable.
 */
export const PhoneAndLink: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => (
  <div className="grid grid-cols-12">
    <BannerSection text={copy.banner} />
    <HeroSection number={data.heroNumber} copy={copy.heroCopy} />
    <PromoSection subCopy1={copy.heroSubCopy1} subCopy2={copy.heroSubCopy2} />
    <CtaSection title={copy.registration}>
      <div className="w-full md:w-fit">
        <ButtonLink
          leftIcon={Phone()}
          href={`${data.ctaPhoneLink}`}
          variant="primary"
          id="phone-cta"
          onClick={() => onCtaClick('phone', data.ctaPhoneLink)}
        >
          {copy.ctaPhoneText}
        </ButtonLink>
      </div>
      <p className="text-body">{copy.phoneSubCopy}</p>
      <p className="text-body mt-space-200 md:mt-0">
        {copy.onlineCopy}&nbsp;
        <a
          className="text-body-link-strong wrap-break-word"
          href={data.ctaOnlineLink}
          id="online-link-cta"
          onClick={() => onCtaClick('online', data.ctaOnlineLink)}
        >
          {copy.ctaOnlineText}
        </a>
      </p>
    </CtaSection>
    <BenefitsSection header={data.benefitsHeader} benefits={data.benefits} />
    <SmallPrintSection data={data} />
  </div>
);
